<template>
  <base-icon-button :title="title"
                    v-on="$listeners">
    <base-material-design-icon icon="assignment_returned"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonAssignmentReturned',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        default: 'Additional sample declaration PDF',
        validator: (value) => value.length > 0,
      },
    },
  };
</script>

<style scoped>

</style>
